import { call, put, takeLatest } from "redux-saga/effects";
import { UserListActions, GET_USER_LIST } from "@redux/reducer";
import { UserListPayload, UserListResponse } from "@type/index";
import ugcRequest from "@util/net/ugc";
import axios, { AxiosResponse } from "axios";
import qs from "qs";

export function* getUserListSaga(action: { payload: UserListPayload }) {
  try {
    const payload: UserListPayload = action.payload;
    yield put(UserListActions.setUserListNotFound(""));
    yield put(UserListActions.getUserListLoading(true));
    const res: AxiosResponse<UserListResponse> = yield call(
      ugcRequest.get,
      "/recommended/users",
      {
        params: {
          page: payload.page,
          page_size: payload.page_size,
          style_gender: payload.style_gender
        },
        paramsSerializer: function (params: UserListPayload) {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      }
    );
    if (res.data.status === "nok") {
      yield put(UserListActions.setUserListNotFound("503"));
    } else {
      yield put(UserListActions.getUserListSuccess(res.data.result));
    }
  } catch (error) {
    if (!axios.isCancel(error)) {
      yield put(UserListActions.setUserListNotFound("503"));
    }
  }
}

export function* watchLoadUserListSaga() {
  yield takeLatest<any>(GET_USER_LIST, getUserListSaga);
}
